<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-beat" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>

<div class="product-modal" id="lead-showrooms" role="document" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
    <div class="modal-content">


      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLongTitle">
          Add Product</h3>
        <button type="button" class="close" (click)="hideDialog()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        
        <div class="row align-items-center  no-gutters">
          <div class="col-md-12">
            <div class="popup-left">
              <form [formGroup]="addProductForm" novalidate (ngSubmit)="onFormSubmit()">
                <div class="modal-form-container">
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label>Name</label>
                      <input type="text" name="name" class="form-control" placeholder="" formControlName="name">
                    </div>  
                    <div class="form-group col-md-3">
                      <label>SKU</label>
                        <input type="text" name="sku" class="form-control" placeholder="" formControlName="sku">
                      </div>
                      
                     
                      <div class="form-group col-md-3">
                        <label>GKC Price</label>
                        <input type="text" name="price_gkc" class="form-control" placeholder="" formControlName="price_gkc">
                    </div> 
                    <div class="form-group col-md-3">
                        <label>Selling Price</label>
                        <input type="text" name="price_selling" class="form-control" placeholder="" formControlName="price_selling">
                    </div> 
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label>Category</label>
                      <select name="category" class="form-control" formControlName="category_id" (click)="setCategoryId($event.target.value)" >
                        <option value=""></option>
                        <option *ngFor="let cat of categoryList" value={{cat.payload.doc.data().id}}>{{cat.payload.doc.data().name}}</option>

                      </select>
                      <div *ngIf="submitted && fval.category_id.errors" class="text-danger">
                        <div *ngIf="fval.category_id.errors.required">Category is required</div>
                      </div>
                      <!-- <span class="text-danger"
                                *ngIf="(addProductForm.category_id.touched || submitted) && addProductForm.category_id.errors?.required">
                                Category is required
                            </span> -->
                  </div>
                  </div>
                  <div class="form-row">

                    <div class="form-group col-md-12">
                        <label>Description</label>
                        <textarea type="text" name="description" class="form-control" placeholder="" formControlName="description"></textarea>
                    </div>

                    <!-- <div class="form-group col-md-12">
                        <label>Price</label>
                        <input type="text" name="price" class="form-control" placeholder="" formControlName="price">
                    </div> -->

                    <div class="form-group col-md-12">
                        <label>Pictures</label>
                        <input type="file" name="pictures" class="form-control" placeholder="" (change)="uploadPicture($event)" multiple="true">
                    </div> 
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <label>Dimensions <span style="font-size: 10px;">(Length)</span></label>
                        <input type="text" name="dimensions_length" class="form-control" placeholder="" formControlName="dimensions_length">
                    </div> 
                      <div class="form-group col-md-3">
                        <label>Dimensions <span style="font-size: 10px;">(width)</span></label>
                        <input type="text" name="dimensions_width" class="form-control" placeholder="" formControlName="dimensions_width">
                    </div> 
                      <div class="form-group col-md-3">
                        <label>Dimensions <span style="font-size: 10px;">(depth)</span></label>
                        <input type="text" name="dimensions_depth" class="form-control" placeholder="" formControlName="dimensions_depth">
                    </div> 
                      <div class="form-group col-md-3">
                        <label>Dimensions <span style="font-size: 10px;">(height)</span></label>
                        <input type="text" name="dimensions_height" class="form-control" placeholder="" formControlName="dimensions_height">
                    </div> 
                    <div class="form-group col-md-6">
                        <label>Weight</label>
                        <input type="text" name="weight" class="form-control" placeholder="" formControlName="weight">
                    </div> 
                    <div class="form-group col-md-6">
                        <label>Shape</label>
                        <input type="text" name="shape" class="form-control" placeholder="" formControlName="shape">
                    </div> 
                    </div>
                   
                    <div class="form-row">
                    <div class="form-group col-md-6">
                        <label>Style</label>
                        <input type="text" name="style" class="form-control" placeholder="" formControlName="style">
                    </div> 
                    <div class="form-group col-md-6">
                        <label>Color</label>
                        <input type="text" name="color" class="form-control" placeholder="" formControlName="color">
                    </div> 
                   

                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label>Video</label>
                        <input type="text" name="video_url" class="form-control" placeholder="" formControlName="video_url">
                    </div> 

                    </div>
                </div>
                <div class="col-md-12 text-center pt-2">
                    <button class="btn btn-info" type="submit">Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
